import { IFormItemProps } from '@/components';

export const LIST_FORM_CONFIG: IFormItemProps[] = [
  {
    props: 'id',
    label: '唯一ID：（id）',
    render: 'hidden',
    uiOptions: {
      disabled: true,
    },
  },
  {
    props: 'tags',
    label: '题材标签',
    render: 'tagInput',
    className: 'row-1',
    uiOptions: {
      max: 5,
    },
  },
  {
    props: 'bgImage',
    label: '封面图',
    render: 'pic',
    className: 'row-2-left',
    uiOptions: {
      width: 231,
      height: 331,
      isShowRichMedia: true,
      maxCount: 1,
    },
  },
  {
    props: 'bgVideo',
    label: '封面视频',
    render: 'video',
    className: 'row-2',
    uiOptions: {
      width: 231,
      height: 331,
      isShowRichMedia: true,
      maxCount: 1,
      dialogConfig: {
        width: 370,
        height: 700,
      },
    },
  },
  {
    props: 'leftLabel',
    label: '左上角角标',
    render: 'customLabel',
    className: 'row-2-left',
    uiOptions: {},
  },
  {
    props: 'rightLabel',
    label: '右上角图标',
    render: 'customLabel',
    className: 'row-2',
    uiOptions: {},
  },
];
